import React from "react";

import { Box, Button, Card, CardContent, Typography } from "@mui/material";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { makeStyles } from "tss-react/mui";

import nutricoachLogo from "@assets/Nutricoach.png";

const useStyles = makeStyles()({
  card: {
    minWidth: "30vw",
    paddingBlock: "12px",
  },
  logo: {
    objectFit: "cover",
    width: "248px",
    marginBottom: "24px",
  },
});

const SessionTimeoutPage: React.FC = () => {
  const { classes } = useStyles();
  const navigate = useNavigate();
  const handleClick = () => {
    Cookies.remove("token");
    navigate("/login", { replace: true });
  };
  return (
    <Box
      height="100vh"
      width="100vw"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
    >
      <img src={nutricoachLogo} className={classes.logo} />
      <Card className={classes.card}>
        <CardContent>
          <Box flex={1}>
            <Typography variant="h5">Session Timeout</Typography>
            <Typography variant="subtitle1" color="textSecondary" gutterBottom>
              You are automatically logged out, please login again to continue
            </Typography>
          </Box>
          <Box
            flex={1}
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
            alignItems="center"
            marginTop="32px"
          >
            <Button onClick={handleClick} size="large">
              Login
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default SessionTimeoutPage;
